import type { ServerFlags } from './flag-definitions.ts'

export const withProjectFlags = ({
  isProjectBiddingDisabled,
  isProjectCreationDisabled,
  isProjectMutationDisabled,
}: Pick<
  ServerFlags,
  | 'isProjectBiddingDisabled'
  | 'isProjectCreationDisabled'
  | 'isProjectMutationDisabled'
>) => {
  return {
    isProjectBiddingEnabledAnd: (predicate: () => boolean) => {
      return !isProjectBiddingDisabled && predicate()
    },
    isProjectCreationEnabledAnd: (predicate: () => boolean) => {
      return !isProjectCreationDisabled && predicate()
    },
    isProjectMutationEnabledAnd: (predicate: () => boolean) => {
      return !isProjectMutationDisabled && predicate()
    },
  }
}
